<div class="page-container">
  <app-screen-loader
    [visible]="cateringProviderPdfLoading"
    [message]="'VENUE.CATERING_PDF_DOWNLOADING' | translate"
  ></app-screen-loader>

  <div class="relative page-edge-cut">
    <div class="form-card">
      @if (!isDetailPage) {
        @if (step == 1) {
          <h1 class="section-heading">
            {{ "VENUE.SELECT" | translate }}
          </h1>
        }
         @if (step == 2 && confirmedVenue?.venue) {
          <h1 class="section-heading">
            {{ "VENUE.SELECTED_VENUE" | translate }}
          </h1>
        }

        <!-- first page -->
        @if (step == 1) {
          @if (roomProfilesLoading || venueSrDetailLoading) {
            <div class="space-y-4 mb-10">
              <app-skeleton-loader [noOfFields]="3"></app-skeleton-loader>
            </div>
          } @else {
            @if (!venues.length) {
              <div class="bg-gray-100 p-6 lg:p-8 mb-10 text-center text-dc-navy font-semibold">
                {{ "VENUE.NO_VENUES_AVAILABLE" | translate }}
              </div>
            }
            <!-- venue cards ----->
            @for (v of venues; track v) {
              <div class="bg-gray-100 p-4 lg:p-6 mb-10">
                <!-- summary row -->
                <div class="flex flex-col lg:flex-row gap-6">
                  <img
                    [src]="v.image"
                    alt=""
                    class="w-full lg:w-52 h-32 object-fill cursor-pointer"
                    (click)="gotoDetailPage(v.id)"
                  />
                  <div class="flex-1 space-y-1">
                    <h3
                      class="text-lg font-semibold text-dc-navy underline underline-offset-4 cursor-pointer"
                      (click)="gotoDetailPage(v.id)"
                    >
                      {{ v.name }}
                    </h3>
                    <div class="mt-2">
                      @if (v.desc) {
                        <p class="text-sm !text-dc-navy">
                          {{ truncateHtmlText(v.desc, 150) }}
                        </p>
                      }
                      <ul
                        class="text-sm space-y-0.5 mt-2 text-dc-navy font-semibold"
                      >
                        <li>
                          {{ "VENUE.PER_DAY" | translate }} : AED
                          {{ v.fullDayRate | number }}
                        </li>
                        <li>
                          {{ "VENUE.BOOKING_TIME" | translate }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <ul class="text-sm space-y-0.5 mt-2 text-dc-navy">
                      <li class="mb-4">
                        <div class="dc-arrow-blue">
                          <span>{{ v.seats }}</span>
                          {{ "VENUE.SEATS" | translate }}
                        </div>
                      </li>
                      @if (v.accessible) {
                        <li class="mb-4">
                          <div class="dc-arrow-red">
                            {{ "VENUE.ACCESSIBLE" | translate }}
                          </div>
                        </li>
                      }
                    </ul>
                    <app-button
                      [type]="'button'"
                      [label]="'VENUE.CHECK' | translate"
                      classesName="btn-edge-cut  btn-width-auto"
                      (onBtnClick)="pickVenue(v)"
                    />
                  </div>
                </div>

                <!-- availability panel, only for selected card --->
                @if (selectedVenue?.id === v.id) {
                  <!-- <div class="mt-6 flex flex-col lg:flex-row gap-8"> -->
                  <div class="mt-6 flex justify-center">
                    <!-- calendar -->
                    <app-inline-calendar
                      [selected]="selectedDate"
                      [bookedDates]="bookedDates"
                      (onDatePicked)="datePicked($event)"
                      (onMonthChanged)="onCalendarMonthChanged($event)"
                    ></app-inline-calendar>
                    <!-- slots / full-day selector -->
                    <div class="flex-1 hidden">
                      <div class="flex gap-2 mb-4">
                        <app-button
                          [type]="'button'"
                          [label]="'VENUE.SLOTS' | translate"
                          classesName="btn-edge-cut"
                          (onBtnClick)="mode = 'slots'"
                        />
                        <app-button
                          [type]="'button'"
                          [label]="'VENUE.FULL_DAY_TAB' | translate"
                          classesName="card-edge-cut-white"
                          (onBtnClick)="mode = 'full'"
                        />
                      </div>
                      <!-- time slots -->
                      @if (mode === "slots") {
                        @for (d of v.days; track d) {
                          <div class="mb-3">
                            <p class="bg-blue-100 text-dc-navy! p-2 py-1 mb-2">
                              <!-- {{ selectedDate | date }} -->
                              {{ d.date | date }}
                            </p>
                            <div class="flex flex-wrap gap-2">
                              @for (s of d.slots || []; track s) {
                                <button
                                  class="border border-dc-navy px-3 py-1 text-sm"
                                  [ngClass]="
                                    selectedSlot === s || s.booked
                                      ? 'bg-dc-navy text-white'
                                      : s?.booked == false
                                        ? 'bg-green-600 text-white'
                                        : ''
                                  "
                                  (click)="pickSlot(s)"
                                >
                                  {{ s.label }}
                                </button>
                              }
                            </div>
                          </div>
                        }
                      }
                      <!-- full day note -->
                      @if (mode === "full") {
                        <p class="text-dc-navy!">
                          {{ "VENUE.FULL_DAY_NOTE" | translate }}
                          {{ selectedDate | date }}
                        </p>
                      }
                    </div>
                  </div>
                  <!-- confirm / reset -->
                  <div class="flex justify-center gap-6 mt-6">
                    <app-button
                      [type]="'button'"
                      [label]="'VENUE.CONFIRM' | translate"
                      classesName="btn-edge-cut"
                      [disabled]="availabilityCheckLoading"
                      (onBtnClick)="confirm()"
                    />
                    <app-button
                      [type]="'button'"
                      [label]="'VENUE.RESET' | translate"
                      classesName="card-edge-cut-white"
                      (onBtnClick)="reset()"
                    />
                  </div>
                }
                <!-- End of availability panel -->
              </div>
            }
          }
          <!-- end of card -->
        }

        <!-- venue event from -->
        @if (step == 2) {
          @if (venueSrDetailLoading) {
            <div class="space-y-4 mb-10">
              <app-skeleton-loader [noOfFields]="3"></app-skeleton-loader>
            </div>
          }
          <!-- selected venue -->
          <div class="bg-gray-100 p-4 lg:p-6 mb-10">
            <div class="flex flex-col lg:flex-row gap-6">
              <img
                [src]="confirmedVenue.venue.image"
                alt=""
                class="w-full lg:w-52 h-32 object-cover"
              />
              <div class="flex-1 space-y-1">
                <h3
                  class="text-lg font-semibold text-dc-navy underline cursor-pointer"
                  (click)="gotoDetailPage(confirmedVenue.venue.id)"
                >
                  {{ confirmedVenue.venue.name }}
                </h3>
                <p class="text-sm text-dc-navy!">
                  {{ truncateHtmlText(confirmedVenue.venue.desc, 150) }}
                </p>
                @if (confirmedVenue.venue.amenities) {
                  <p class="text-sm text-dc-navy!">
                    {{
                      "VENUE.AMENITIES"
                        | translate
                          : { amenities: confirmedVenue.venue.amenities }
                    }}
                  </p>
                }
                <ul class="text-sm space-y-0.5 mt-2 text-dc-navy font-semibold">
                  <li>
                    {{ confirmedVenue.day | date: "MMMM dd" }}
                  </li>
                  <li>
                    {{ "VENUE.BOOKING_TIME" | translate }}
                    <!-- {{
                      confirmedVenue.slot != "full-day"
                        ? confirmedVenue.slot?.label
                        : ("VENUE.FULL_DAY_TAB" | translate)
                    }} -->
                  </li>
                </ul>
              </div>
              <div>
                <ul class="text-sm space-y-0.5 mt-2 text-dc-navy">
                  <li class="mb-3">
                    <div class="dc-arrow-blue">
                       <!-- eventFormInitialData ? eventFormInitialData['attendeeCount'] : confirmedVenue.venue.seats -->
                        
                      <span class="font-semibold">{{
                      confirmedVenue.venue.seats
                      }}</span>
                      {{ "VENUE.SEATS" | translate }}
                    </div>
                  </li>
                  <!-- @if (confirmedVenue.venue.accessible) { -->
                    <li class="mb-3">
                      <div class="dc-arrow-red">
                        {{ "VENUE.ACCESSIBLE" | translate }}
                      </div>
                    </li>
                  <!-- } -->
                </ul>
                @if (allowVenueActions) {
                  <app-button
                    [type]="'button'"
                    [label]="'VENUE.CHANGE_BOOKING' | translate"
                    classesName="btn-edge-cut  btn-width-auto"
                    (onBtnClick)="changeBooking()"
                  />
                }
              </div>
            </div>
          </div>
          @if (showReservationHoldMessage) {
            <app-validation-message
              type="warning"
              [content]="{
                title: 'VENUE.RESERVATION_HOLD_TITLE' | translate,
                message: 'VENUE.RESERVATION_HOLD_TEXT' | translate,
              }"
            />
          }
          <!-- message one -->
          <app-validation-message
            type="info"
            [content]="{
              title: 'VENUE.CANCEL_TITLE' | translate,
              message: 'VENUE.CANCEL_TEXT' | translate,
              sections: [
                {
                  title: '',
                  items: [
                    'VENUE.CANCEL_30' | translate,
                    'VENUE.CANCEL_7' | translate,
                    'VENUE.CANCEL_3' | translate,
                  ],
                },
              ],
            }"
          />
          <!-- message two -->
          <app-validation-message
            type="info"
            (onItemClick)="onValidationItemClick($event)"
            [content]="{
              title: 'VENUE.VISIT_TITLE' | translate,
              message: '',
              sections: [
                {
                  title: 'VENUE.PHOTO_TITLE' | translate,
                  items: ['VENUE.PHOTO_TEXT' | translate],
                },
                {
                  title: 'VENUE.SMOKE_TITLE' | translate,
                  items: ['VENUE.SMOKE_TEXT' | translate],
                },
                {
                  title: 'VENUE.DRESS_TITLE' | translate,
                  items: [
                    'VENUE.DRESS_MEN' | translate,
                    'VENUE.DRESS_WOMEN' | translate,
                  ],
                },
                {
                  title: 'VENUE.CATERING_TITLE' | translate,
                  items: ['VENUE.CATERING_TEXT' | translate],
                },
              ],
            }"
          />
          <app-event-form
            [masterDataLoading]="masterDataLoading"
            [submitting]="roomReservationLoading"
            [noOfSeats]="confirmedVenue?.venue?.seats || 0"
            [aminities]="confirmedVenue?.venue?.amenities || ''"
            [initialData]="eventFormInitialData"
            [eventTypeOptions]="eventTypeOptions"
            [roomSetupOptions]="roomSetupOptions"
            [cateringOptionOptions]="cateringOptionOptions"
            [cateringTypeOptions]="cateringTypeOptions"
            [reminderOptions]="reminderOptions"
            [technicalErrorMsg]="technicalErrorMsg"
            [srFolder]="srFolder"
            [mainFromSectionDocs]="mainFromSectionDocs"
            [showActions]="allowVenueActions"
            [srStatus]="currentSrStatus"
            [cancellationOptions]="cancellationOptions"
            (progressChange)="onEventFormProgressChange($event)"
            (formSubmit)="onEventFormSubmit($event)"
            (cancelBookingSubmit)="onCancelBookingSubmit($event)"
            (saveAndClose)="onSaveAndClose()"
            (folderMissing)="openFolder()"
          ></app-event-form>
        }
        <!-- End of event form -->
      }
    </div>
  </div>
</div>

<!-- form progress -->
<div>
  <app-service-progress
    [serviceName]="'VENUE.SERIVCE_NAME' | translate"
    [completePercentage]="formProgress"
  />
</div>

<!-- room detail modal -->
@if (showVenueDetailPopup && selectedVenueDetail) {
  <div
    class="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
  >
    <div class="bg-white w-full max-w-5xl max-h-[90vh] overflow-auto">
      <app-venue-detail
        [venue]="selectedVenueDetail"
        [isPopup]="true"
        (close)="closeVenueDetailPopup()"
      ></app-venue-detail>
    </div>
  </div>
}
